import { COLORS } from '@/styles/colors';
import { bodySmall, poppinsRegularFont } from '@/styles/typography';
import styled from 'styled-components';
import { flex } from '@/styles/layout';

export const DetailsBlockNotes = styled.div`
  ${flex({ flexDirection: 'column' })};
  border-top: 1px solid ${COLORS.grey[400]};
  padding: 12px 0 0;
  width: 100%;
`;

export const DetailsBlockNotesLabel = styled.div<{ emptyNotes?: boolean }>`
  ${poppinsRegularFont};
  ${bodySmall};
  color: ${COLORS.grey[600]};

  ${({ emptyNotes }) =>
    emptyNotes &&
    `
      ${flex({ justifyContent: 'space-between' })};
  `};
`;

export const DetailsBlockNotesMessage = styled.div`
  color: ${COLORS.black};
  ${poppinsRegularFont};
  ${bodySmall};
  margin-top: 6px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`;

export const EmptyNotes = styled.div`
  margin-left: auto;
  ${poppinsRegularFont};
  color: ${COLORS.black};
`;
